import axios from "axios";
import _ from "lodash";

const axiosInstance = axios.create({
  baseURL: "https://api.paraswap.io",
  timeout: 10000,
});

export async function getQuote(params: any) {
  return (await axiosInstance.get("/prices", { params })).data.priceRoute;
}

export async function buildTransaction(allParams: any) {
  const queryParamKeys = ["gasPrice", "ignoreChecks", "ignoreGasEstimate", "onlyParams"];
  const params = _.pick(allParams, queryParamKeys);
  const bodyKeys = ["srcToken", "srcDecimals", "destToken", "destDecimals", "srcAmount", "destAmount", "priceRoute", "slippage", "userAddress", "txOrigin", "receiver", "partnerAddress", "partnerFeeBps", "partner", "permit", "deadline", "isCapSurplus", "takeSurplus", "isSurplusToUser", "isDirectFeeTransfer"];
  const body = _.pick(allParams, bodyKeys);
  return (await axiosInstance.post(`/transactions/${allParams.network}`, body, { params })).data;
}

